<template>
  <div>
    <h1 class="font-family-display font-weight-bold mb-8">
      {{ $t('create_first_stage') }}
    </h1>
    <p class="mb-24">
      {{ $t('already_have_an_account') }}
      <router-link :to="{ name: 'Login' }">
        {{ $t('login') }}
      </router-link>
    </p>
    <StageForm :is-onboarding-stage-creation="true" />
  </div>
</template>

<script setup>
import { onMounted, onUpdated } from 'vue'
import StageForm from '@/components/forms/StageForm.vue'
import { useCommonStore } from '@/stores/commonStore'

const { setActiveStep } = useCommonStore()

onMounted(() => setActiveStep('StageOnboarding'))

onUpdated(() => setActiveStep('StageOnboarding'))
</script>
